import {
  BuildingOfficeIcon,
  UserIcon,
  DocumentTextIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";

export const diligenciaItems = [
  {
    id: "dividas",
    label: "Dívidas",
    icon: BanknotesIcon,
    description:
      "Atalhos para descobrir todas as dívidas de caráter propter rem",
  },
  {
    id: "documentos",
    label: "Imóvel",
    icon: DocumentTextIcon,
    description:
      "Alguns documentos importantes de se ter em mão antes e depois de arrematar",
  },
  {
    id: "proprietarios",
    label: "Ex-proprietário",
    icon: UserIcon,
    description:
      "Consulte informações sobre o antigo proprietário para não ter nenhuma surpresa",
  },
  {
    id: "processos",
    label: "Processos",
    icon: BuildingOfficeIcon,
    description:
      "Encontre processos relacionados ao ex-proprietário e ao imóvel",
  },
];
